import browser from "webextension-polyfill";
import { youTubeWallDetected, youTubeNavigation, toastShownEvent, errorEvent, ErrorType, } from "../shared/index.js";
import { recordEvent } from "./shared.js";
const adWallSelector = "ytd-enforcement-message-view-model";
const playerErrorSelector = ".ytp-error";
const userAvatarSelector = "button#avatar-btn";
const toastSelector = ".yt-notification-action-renderer a[href*='check_ad_blockers']";
let wallDetected = false;
let domObserver;
const alreadyLoggedSymbol = Symbol("alreadyLoggedSymbol");
function isElement(candidate) {
    return candidate instanceof Element;
}
async function adWallSelectorFound(hasDismiss) {
    var _a;
    const videoPlayer = document.querySelector("video");
    const currentPlaybackTime = (_a = videoPlayer === null || videoPlayer === void 0 ? void 0 : videoPlayer.currentTime) !== null && _a !== void 0 ? _a : 0;
    const userLoggedIn = !!document.querySelector(userAvatarSelector);
    void browser.runtime.sendMessage({
        type: youTubeWallDetected,
        userLoggedIn,
        currentPlaybackTime,
        hasDismiss,
    });
}
async function handleToastNotification(node) {
    const anchorNode = node;
    if (anchorNode[alreadyLoggedSymbol]) {
        return;
    }
    anchorNode[alreadyLoggedSymbol] = true;
    void recordEvent(toastShownEvent);
}
async function handlePlayerError(node) {
    const errorNode = node;
    if (errorNode[alreadyLoggedSymbol]) {
        return;
    }
    errorNode[alreadyLoggedSymbol] = true;
    void recordEvent(errorEvent, {
        category: ErrorType.PLAYER_ERROR,
    });
}
function handleMutations(mutations) {
    for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
            if (!isElement(node)) {
                continue;
            }
            const elements = [
                node,
                ...Array.from(node.querySelectorAll([adWallSelector, toastSelector, playerErrorSelector].join(","))),
            ];
            for (const elem of elements) {
                if (elem.tagName === adWallSelector.toUpperCase() && !wallDetected) {
                    const hasDismiss = !!elem.querySelector("#dismiss-button");
                    void adWallSelectorFound(hasDismiss);
                    wallDetected = true;
                }
                else if (elem.tagName === "A" && elem.matches(toastSelector)) {
                    void handleToastNotification(elem);
                }
                else if (elem.tagName === "DIV" &&
                    elem.matches(playerErrorSelector)) {
                    void handlePlayerError(elem);
                }
            }
        }
    }
}
function initializeObserver() {
    domObserver = new MutationObserver(handleMutations);
    domObserver.observe(document, {
        attributes: false,
        childList: true,
        characterData: false,
        subtree: true,
    });
}
function logInitialEvent() {
    const userLoggedIn = !!document.querySelector(userAvatarSelector);
    void browser.runtime.sendMessage({ type: youTubeNavigation, userLoggedIn });
}
function handleLoadEvent() {
    setTimeout(() => {
        logInitialEvent();
    }, 5000);
}
export function start() {
    initializeObserver();
    window.addEventListener("load", handleLoadEvent, { once: true });
}
